import React from 'react';
import { RefreshIcon } from 'twain-sport-fe-mono';
import classes from './GeneralError.scss';

export const GeneralError: React.FC = () => (
    <div className={classes.container}>
        <h3>Whoops...</h3>
        <span>Something went wrong</span>
        <button type="button" className={classes.action} onClick={() => window.location.reload()}>
            TRY TO REFRESH &nbsp; <RefreshIcon />
        </button>
    </div>
);
